require('../styles/openseason.less')
import 'babel-polyfill'

import * as Accordion from './accordion'
import * as Acknowledgement from './acknowledgement'
import * as AjaxForms from './ajax-forms'
import * as Embeds from './embeds'
import * as Lazyload from './lazyload'
import * as ExternalLinks from './external-links'
import * as SmoothScroll from './smooth-scroll'
import * as Parallax from './parallax'
import * as Marquee from './marquee'
import * as Events from './events'
import * as Menu from './menu'
import * as Slides from './slides'
import * as Fun from './fun'
import * as Modal from './modal'

Accordion.init()
Acknowledgement.init()
AjaxForms.init()
Embeds.init()
Lazyload.init()
ExternalLinks.init()
SmoothScroll.init()
Marquee.init()
Parallax.init()
Events.init()
Menu.init()
Slides.init('openseason')
Fun.init()
Modal.init()
